// About Logo 3D Animation
document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById("threejs-logo-container");
  if (!container) return; // Exit if container not found

  const width = container.clientWidth;
  const height = container.clientHeight;
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1000);
  camera.position.z = 50;

  const renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true,
  });
  renderer.setClearColor(0xffffff, 0);
  renderer.setSize(width, height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  container.appendChild(renderer.domElement);

  // Load texture and adjust its settings
  const textureLoader = new THREE.TextureLoader();
  const texture = textureLoader.load(
    "https://cdn.shopify.com/s/files/1/0887/0808/8139/files/texture.jpg",
    function (texture) {
      texture.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
      texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
    }
  );

  // Soft lighting for better performance and natural look
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
  scene.add(ambientLight);

  const hemisphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.3);
  scene.add(hemisphereLight);

  const softLight = new THREE.DirectionalLight(0xffffff, 0.2);
  softLight.position.set(5, 5, 5);
  softLight.castShadow = false;
  scene.add(softLight);

  // Material with a texture and soft reflections
  const material = new THREE.MeshPhysicalMaterial({
    map: texture,
    metalness: 0.1,
    roughness: 0.7,
    clearcoat: 0.15,
    clearcoatRoughness: 0.7,
    side: THREE.DoubleSide,
    envMapIntensity: 0.3,
  });

  // SVG path data
  const svgPathData = "M85.5951 71.0916V70.9916L80.2951 64.1916C86.8951 52.5916 87.5951 38.6916 82.4951 26.3916C82.2951 20.9916 79.3951 15.9916 74.7951 13.2916C74.1951 12.8916 73.5951 12.5916 72.8951 12.2916C57.8951 -2.40835 34.5951 -4.10835 17.6951 8.19166C15.2951 8.69166 12.9951 9.69165 10.8951 11.0916C6.1951 14.3916 3.3951 19.7916 3.6951 25.4916C-0.504907 34.8916 -1.1049 45.4916 1.7951 55.3916H0.895092L3.8951 76.7916H6.0951L6.9951 74.3916C7.0951 73.9916 7.4951 73.6916 7.7951 73.5916C8.1951 73.3916 8.5951 73.3916 8.9951 73.4916C10.5951 73.7916 12.2951 74.3916 13.8951 74.7916C31.1951 90.5916 57.8951 89.6916 73.9951 72.6916L77.5951 77.1916H92.9951V75.1916C90.0951 74.8916 87.3951 73.3916 85.5951 71.0916ZM83.7951 52.0916V52.1916L83.2951 54.2916L69.0951 50.0916L66.4951 46.6916L84.3951 49.2916L83.7951 52.0916ZM84.8951 46.2916H84.7951L84.5951 48.4916L65.6951 45.7916L64.4951 44.2916C65.9951 44.2916 67.4951 43.8916 68.8951 43.4916H84.8951V46.2916ZM52.0951 13.0916V13.1916C53.2951 13.1916 54.5951 13.1916 55.8951 13.3916L47.6951 31.2916V28.2916L52.0951 13.0916ZM47.6951 24.8916V13.1916H51.1951L47.6951 24.8916ZM56.8951 13.4916C57.8951 13.4916 58.9951 13.6916 59.9951 13.8916C60.2951 13.8916 60.5951 13.8916 60.9951 14.0916L47.6951 34.6916V33.6916L56.8951 13.4916ZM61.8951 14.2916C63.1951 14.6916 64.4951 15.2916 65.5951 16.0916L47.6951 36.7916V36.3916L61.8951 14.2916ZM66.2951 16.5916C67.3951 17.4916 68.2951 18.4916 69.0951 19.5916L47.6951 38.1916L66.2951 16.5916ZM49.3951 41.5916L68.0951 36.0916C66.7951 37.5916 65.0951 38.7916 63.1951 39.5916L49.3951 41.5916ZM53.9951 47.5916L49.5951 45.5916H49.7951L53.1951 46.5916L53.9951 47.5916ZM49.1951 40.6916L70.9951 30.6916C70.5951 32.1916 69.9951 33.5916 69.0951 34.7916L49.1951 40.6916ZM55.2951 49.2916V49.1916L57.2951 51.7916L48.6951 46.2916L55.2951 49.2916ZM59.2451 54.1716L59.1851 54.1016L59.2851 54.2016L59.2451 54.1716L65.6851 62.2016L48.2851 47.1016L59.2451 54.1716ZM82.3951 28.7916L82.7951 29.8916L83.0951 30.6916L81.9951 30.9916C82.1951 30.2916 82.2951 29.4916 82.3951 28.7916ZM81.5951 32.0916L81.6951 31.9916C81.6951 31.9916 81.6751 32.0416 81.6651 32.0716L83.2951 31.5916L83.9951 34.3916L84.3951 36.4916L78.5951 37.2916C79.8751 35.8116 80.9551 33.9416 81.6651 32.0716L81.5951 32.0916ZM77.4951 38.4916L84.4951 37.4916L84.7951 40.2916V42.4916H71.4951C73.6951 41.4916 75.7951 40.1916 77.4951 38.4916ZM71.3951 29.4916H71.2951L48.7951 39.7916L71.3951 25.2916C71.5951 26.6916 71.5951 28.0916 71.3951 29.4916ZM48.7351 38.6116L48.2951 38.9916V38.8916L48.7351 38.6116L69.6951 20.3916C70.3951 21.5916 70.8951 22.8916 71.1951 24.1916L48.7351 38.6116ZM68.2951 9.39165V9.49165L69.9951 10.8916C68.2951 10.3916 66.5951 9.99166 64.8951 9.69166L65.9951 7.79165L68.2951 9.39165ZM63.2951 6.09165V6.19165L65.1951 7.29165L63.7951 9.49165C62.7951 9.39165 61.7951 9.29165 60.8951 9.29165H58.7951L60.7951 4.79165L63.2951 6.09165ZM57.7951 3.59165V3.69165L59.7951 4.49165L57.5951 9.29165H53.0951L55.0951 2.69165L57.7951 3.59165ZM52.0951 1.99165L54.1951 2.49165L52.1951 9.39165H48.1951L49.2951 1.39165L52.0951 1.99165ZM40.1951 0.991656H42.3951V9.39165H38.5951L37.3951 1.29165L40.1951 0.991656ZM34.2951 1.79165L36.4951 1.39165L37.6951 9.39165H33.6951L31.6951 2.49165L34.3951 1.79165H34.2951ZM30.3551 14.2216C30.3551 14.2216 30.3151 14.2016 30.2951 14.1916V14.0916L30.3551 14.2216C31.9351 15.0216 33.5151 16.1016 34.8951 17.2916L37.5951 26.5916V30.1916L30.3551 14.2216ZM37.5951 32.4916V33.7916L23.6951 11.9916C25.4951 12.2916 27.2951 12.7916 28.9951 13.4916L37.5951 32.4916ZM36.2951 18.5916C36.7951 19.0916 37.1951 19.5916 37.5951 20.1916V23.1916L36.2951 18.5916ZM28.3951 3.49165H28.4951L30.5951 2.79165L32.4951 9.39165H29.0951C28.6951 9.19166 28.2951 8.99166 27.7951 8.89165L25.7951 4.59165L28.3951 3.49165ZM22.8951 5.99165H22.9951L24.9951 4.99165L26.5951 8.59165C24.6951 8.09165 22.7951 7.79165 20.7951 7.89165L20.4951 7.39165L22.8951 5.99165ZM22.3951 11.9916L37.5951 35.5916V36.0916L17.5951 13.0916C19.0951 12.2916 20.6951 11.9916 22.3951 11.9916ZM16.7951 13.5916L37.5951 37.5916V37.7916L13.5951 16.8916C14.3951 15.5916 15.4951 14.3916 16.7951 13.5916ZM13.0951 17.7916H13.1951L37.5951 38.9916L12.4951 22.8916C12.2951 21.1916 12.4951 19.3916 13.0951 17.7916ZM23.0951 73.0916H22.9951C21.3351 73.0816 19.7651 72.8816 18.1951 72.2916L33.2951 54.8916C33.5951 55.1916 33.7951 55.5916 33.9951 55.9916L22.9951 73.0916C22.9951 73.0916 23.0551 73.0916 23.0951 73.0916ZM34.4951 56.9916V56.8916C34.7951 57.4916 34.9951 58.0916 35.1951 58.6916L29.1951 71.7916C28.7951 71.9916 28.2951 72.1916 27.7951 72.3916C26.5951 72.6916 25.3951 72.9916 24.1951 73.0916L34.4951 56.9916ZM34.2951 41.1916L34.1951 41.2916C33.8951 41.0916 33.3951 40.7916 33.0951 40.5916L36.3951 41.4916L34.2951 41.1916ZM29.8951 38.7916V38.6916C29.1951 38.2916 28.3951 37.8916 27.5951 37.3916C25.7951 36.3916 23.9951 35.2916 22.2951 34.1916L36.5951 40.7916L29.8951 38.7916ZM18.3951 31.0916V31.1916C17.5951 30.5916 16.8951 29.9916 16.0951 29.3916C14.4951 27.9916 13.2951 26.1916 12.7951 24.0916L37.0951 39.6916L18.3951 31.0916ZM3.3951 28.7916V28.8916L3.8951 27.4916C4.0951 28.7916 4.4951 30.0916 4.9951 31.2916L2.7951 30.5916L3.3951 28.7916ZM1.9951 33.7916L2.4951 31.6916L5.4951 32.5916C6.1951 33.7916 6.9951 35.0916 7.8951 36.0916C8.3951 36.6916 8.9951 37.1916 9.4951 37.7916L1.3951 36.5916L1.9951 33.7916ZM0.995093 39.7916L1.0951 39.6916L1.2951 37.4916L10.7951 38.8916C12.3951 40.2916 14.0951 41.4916 15.9951 42.5916H0.995093V39.7916ZM0.995093 45.6916V43.4916H17.7951C19.0951 44.1916 20.3951 44.8916 21.5951 45.5916L1.2951 48.4916L0.995093 45.6916ZM1.7951 51.5916L1.3951 49.4916L22.7951 46.3916C23.4951 46.8916 24.1951 47.3916 24.8951 47.7916L2.3951 54.3916L1.7951 51.5916ZM3.1951 55.3916H2.6951L25.8951 48.4916C26.3951 48.7916 26.8951 49.1916 27.3951 49.5916L4.7951 59.8916C4.0951 58.3916 3.5951 56.8916 3.1951 55.3916ZM7.9951 64.9916V64.8916C6.9951 63.5916 6.0951 62.1916 5.2951 60.7916L28.2951 50.2916C28.6951 50.5916 28.9951 50.8916 29.3951 51.1916L7.9951 64.9916ZM8.5951 65.6916L30.0951 51.8916C30.3951 52.1916 30.6951 52.4916 30.9951 52.6916L12.1951 69.0916C10.8951 68.0916 9.6951 66.9916 8.5951 65.6916ZM13.0551 69.5416L12.9951 69.5916V69.4916C12.9951 69.4916 13.0351 69.5216 13.0551 69.5416L31.6951 53.2916C31.7951 53.4916 32.4951 54.0916 32.5951 54.0916L17.1951 71.8916C16.3951 71.5916 15.5951 71.1916 14.7951 70.6916C14.2151 70.3016 13.6351 70.0116 13.0551 69.5416ZM17.5951 76.7916L17.6951 76.6916L16.0951 75.4916L18.6951 76.1916L20.7951 76.5916L19.6951 78.2916L17.5951 76.7916ZM22.4951 79.7916L20.5951 78.6916L21.8951 76.6916H26.9951L24.9951 81.0916L22.4951 79.7916ZM27.8951 82.3916V82.2916L25.8951 81.4916L28.0951 76.6916H32.4951L30.5951 83.2916L27.8951 82.3916ZM33.7951 83.9916H33.6951L31.5951 83.4916L33.5951 76.5916H37.6951L36.4951 84.5916L33.7951 83.9916ZM42.4951 84.9916H39.5951L37.3951 84.6916L38.5951 76.5916H42.4951V84.9916ZM43.2951 0.991656H46.1951L48.3951 1.29165L47.1951 9.39165H43.2951V0.991656ZM45.6951 84.9916H43.3951V76.5916H47.2951L48.4951 84.6916L45.6951 84.9916ZM47.6951 57.6916V54.6916L56.8951 74.6916C55.3951 74.6916 53.8951 74.3916 52.4951 73.9916L47.6951 57.6916ZM51.4951 73.5916H51.3951C50.7951 73.3916 50.1951 73.0916 49.6951 72.7916C49.1951 72.4916 48.8951 72.0916 48.6951 71.5916C48.0951 69.6916 47.7951 67.5916 47.7951 65.5916V61.0916L51.4951 73.5916ZM51.4951 84.0916V84.1916L49.2951 84.5916L48.1951 76.5916H52.1951L54.1951 83.4916L51.4951 84.0916ZM57.2951 82.5916V82.4916L55.1951 83.1916L53.1951 76.5916H56.8951V74.8916L59.8951 81.4916L57.2951 82.5916ZM62.7951 80.0916L60.7951 81.0916L47.6951 52.3916V51.3916L65.1951 78.6916L62.7951 80.0916ZM67.7951 76.7916L65.8951 78.0916L47.5951 49.5916V49.2916L69.8951 75.0916H69.9951L67.7951 76.7916ZM73.4951 71.8916L71.9951 73.3916L70.7951 74.4916L47.6951 47.7916L68.9951 66.2916L73.4951 71.7916V71.8916ZM70.2951 51.5916L70.1951 51.4916L82.9951 55.2916L82.0951 57.9916L81.2951 60.0916L74.4951 56.9916L70.2951 51.5916ZM79.5951 63.2916V63.3916L75.6951 58.4916L80.8951 60.7916L80.1951 62.1916L79.5951 63.2916Z";
  const svgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="${svgPathData}" fill="#06AFD1"/></svg>`;

  if (svgPathData) {
    const loader = new THREE.SVGLoader();
    const svgData = loader.parse(svgString);
    const paths = svgData.paths;
    const logoGroup = new THREE.Group();

    paths.forEach((path) => {
      const shapes = path.toShapes(false);
      shapes.forEach((shape) => {
        const geometry = new THREE.ExtrudeGeometry(shape, {
          depth: 3,
          bevelEnabled: true,
          bevelThickness: 0.5,
          bevelSize: 0.3,
          bevelSegments: 8,
          curveSegments: 12,
          steps: 2,
        });

        // Custom UV mapping
        geometry.computeBoundingBox();
        const bbox = geometry.boundingBox;
        const range = new THREE.Vector2(
          bbox.max.x - bbox.min.x,
          bbox.max.y - bbox.min.y
        );

        const uvs = geometry.attributes.uv;
        for (let i = 0; i < uvs.count; i++) {
          uvs.setXY(
            i,
            (geometry.attributes.position.getX(i) - bbox.min.x) / range.x,
            (geometry.attributes.position.getY(i) - bbox.min.y) / range.y
          );
        }

        const mesh = new THREE.Mesh(geometry, material);
        logoGroup.add(mesh);
      });
    });

    const pivotGroup = new THREE.Group();
    scene.add(pivotGroup);
    logoGroup.scale.set(0.3, 0.3, 0.3);
    const box = new THREE.Box3().setFromObject(logoGroup);
    const center = box.getCenter(new THREE.Vector3());
    logoGroup.position.x = -center.x;
    logoGroup.position.y = -center.y;
    pivotGroup.add(logoGroup);
    pivotGroup.rotation.x = Math.PI;
    pivotGroup.rotation.y = 0;

    // Increased overall speed
    const minRotationSpeed = 0.5;  // Example: Adjust this value (radians per second)
    const maxRotationSpeed = 2.0;  // Example: Adjust this value (radians per second)
    const FULL_ROTATION = Math.PI * 2;
    let isInView = false;
    let completedRotations = 0;
    let lastTime = 0; // Add this line to track the last frame time

    // Setup the ScrollTrigger
    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.create({
        trigger: ".about-us",
        start: "top 80%", 
        end: "bottom 20%",
        onEnter: () => { isInView = true; },
        onLeave: () => { isInView = false; },
        onEnterBack: () => { isInView = true; },
        onLeaveBack: () => { isInView = false; }
      });
    } else {
      // If GSAP is not available, always rotate
      isInView = true;
    }

    function animate(currentTime) { // Pass current time provided by requestAnimationFrame
      requestAnimationFrame(animate);

      // Calculate delta time (time since last frame) in seconds
      currentTime *= 0.001;  // Convert milliseconds to seconds
      const deltaTime = currentTime - lastTime;
      lastTime = currentTime;
      
      if (isInView) {
        // Get the normalized angle (0 to 2π)
        const normalizedAngle = pivotGroup.rotation.y % FULL_ROTATION;
        const positiveAngle = normalizedAngle < 0 ? normalizedAngle + FULL_ROTATION : normalizedAngle;
        
        // Track completed rotations (this logic might need adjustment with dt)
        // if (positiveAngle < 0.1 && pivotGroup.rotation.y > 0.1) {
        //   completedRotations++;
        // }

        // Create a swoosh effect with a bell curve
        const progress = positiveAngle / FULL_ROTATION;
        const speedFactor = Math.sin(progress * Math.PI); 
        
        // Calculate the final speed based on the speed factor
        // IMPORTANT: Adjust these base speeds as they now represent radians per SECOND
        // You'll likely need much smaller values than before. Start by dividing previous values by ~60.
        const currentSpeed = minRotationSpeed + speedFactor * (maxRotationSpeed - minRotationSpeed);
        
        // Apply the rotation, scaled by delta time
        pivotGroup.rotation.y += currentSpeed * deltaTime;
        
        // Reset logic might also need adjustment depending on the desired effect
        // if (pivotGroup.rotation.y > FULL_ROTATION) {
        //    pivotGroup.rotation.y %= FULL_ROTATION; // Use modulo for clean reset
        // }
      }
      
      renderer.render(scene, camera);
    }
    animate(0); // Start the animation loop, passing initial time
  }

  window.addEventListener("resize", () => {
    const width = container.clientWidth;
    const height = container.clientHeight;
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  });
}); 